export default __webpack_public_path__ + "static/media/kanipakam.9b4bfaa2.webp";